import script from "./workspace-not-found.vue?vue&type=script&setup=true&lang=js"
export * from "./workspace-not-found.vue?vue&type=script&setup=true&lang=js"

import "./workspace-not-found.vue?vue&type=style&index=0&id=7648b432&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7648b432"]])

export default __exports__